Service = App.loadClass 'core::Angular/Service'

class exports.DownloadService extends Service
    constructor: (@http, @window, @modal) ->
        undefined

    downloadFile: (layer_id, type) =>

        @layer_id = layer_id

        # set the download url
        switch (type)
            when 'shapefile'
                @url = "backend/grower/layers/prescription-map/download-shp?id=#{@layer_id}"
            when 'rxmap'
                @url = "backend/grower/layers/planting-rx/download?id=#{@layer_id}"
            when 'rxmap_proprietary'
                @url = "backend/grower/layers/planting-rx/download-proprietary?id=#{@layer_id}"
            when 'controller'
                @url = "backend/grower/layers/prescription-map/download-controller?id=#{@layer_id}"

        @checkDisclaimer()


    checkDisclaimer: () =>
        @http.post('backend/grower/rx-warning/disclaimer-info', { layer_id: @layer_id }).then (response) =>
            if response?.data?.status?.type is 'success'
                info = response.data.data
                @showDisclaimer(info)
            else
                @window.open(@url, 'blank')


    showDisclaimer: (info) =>
        dialog = @modal.open
            windowClass: 'small_dialog'
            template: (() =>
                return @http.post('backend/grower/rx-warning/show-disclaimer', { info: info }).then (response) =>
                    return response.data
            )()
            controller: 'Data.Controllers.RxWarningController'

        dialog.result.then () =>
            @window.open(@url, '_blank')
